export default __webpack_public_path__ + "static/G3-ALPHA-4f32cfc94d75741476d6bad456f28b2a.png";